import { Card, Tab, Tabs, } from 'external/react'
import useAdmin from 'context/admin-context/hook'

import Configuration from './Configuration'

export default function OfferConfigurationPage () {
	const {currentOffer} = useAdmin()
	return (
		<Card.Body>
		{currentOffer.loaded && (
				<Tabs defaultActiveKey='configuration' id='fill-tab-example' className='mb-3' >
				<Tab eventKey='configuration' title='Configuración'>
					<Configuration />
				</Tab>
			</Tabs>
		)}
		</Card.Body>
	)
}